import { createFileRoute } from "@tanstack/react-router";
import { ChassisCodes } from "@/features/settings/chassis-codes";

export const Route = createFileRoute("/settings/chassis-codes")({
  component: ChassisCodes,
});
